import {mainQuery} from '@github-ui/react-core/future/main-query'

import {reposFinderAppBuilder} from '../config/app-builder'
import type {LayoutPayload} from '../types'

export const reposFinderLayoutRoute = reposFinderAppBuilder.createQueryRouteConfig('reposFinderLayoutRoute', {
  path: '/repos',
  queries: [
    mainQuery<LayoutPayload>({
      queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
      staleTimeForNavigation: 360000, // 6 minutes in milliseconds
    }),
  ],
  uiServiceOptions: {
    gates: [
      {flag: 'ui_route_repos', onFail: {passthroughId: 'repos'}},
      {holdback: true, onFail: {passthroughId: 'repos'}},
    ],
    navigation: {
      contextRegion: {crumbs: [{label: 'Repositories', href: '/repos'}]},
    },
    tsrConfig: {
      head: () => ({
        meta: [{title: 'Repositories'}],
      }),
      staticData: {
        showSsoPrompt: true,
        sso: ['mainQuery', 'sso'],
        reactAppName: 'repos',
      },
    },
  },
})
